import React from 'react';
import { Typography } from '@mui/material';

interface PageTitleProps {
    title: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({ title }) => {
    return (
        <div className="flex items-center mb-8">
            <Typography
                variant="h4" // Changed from h3 to h4
                sx={{
                    color: '#102A43',
                    fontWeight: 800,
                    letterSpacing: '-0.02em',
                    fontSize: { xs: '1.75rem', md: '2.25rem' } // Adjusted down
                }}
            >
                {title}
            </Typography>
        </div>
    );
};
